import command from "@utils/command";
import { controlNames } from "@constants";

export default {
  name: "ReindeerMakeover",
  data: function() {
    return {
      selectedReindeer: 'buck',
      rudolphReindeer: null, // Track which reindeer is currently Rudolph
      colorSwatches: [
        '#FF0000', // Red
        '#DC143C', // Crimson
        '#FF6B00', // Orange
        '#FF8C00', // Dark Orange
        '#FFD700', // Gold
        '#FFFF00', // Yellow
        '#00FF00', // Green
        '#32CD32', // Lime Green
        '#90EE90', // Light Green
        '#008000', // Dark Green
        '#0000FF', // Blue
        '#1E90FF', // Dodger Blue
        '#00FFFF', // Cyan
        '#4B0082', // Indigo
        '#8B00FF', // Violet
        '#9400D3', // Dark Violet
        '#FF1493', // Hot Pink
        '#FFB6C1', // Light Pink
        '#FF69B4', // Hot Pink 2
        '#FFC0CB', // Pink
        '#FFFFFF', // White
        '#C0C0C0', // Silver
        '#FFE4E1', // Misty Rose
        '#E6E6FA', // Lavender
        '#000000', // Black (special: body=off, eyes=body color)
      ],
      reindeerConfig: {
        buck: {
          eyeColor: '#0000FF', // Blue
          bodyColor: '#FFFFFF', // White
        },
        'doe-1': {
          eyeColor: '#0000FF', // Blue
          bodyColor: '#FFFFFF', // White
        },
        'doe-2': {
          eyeColor: '#0000FF', // Blue
          bodyColor: '#FFFFFF', // White
        }
      }
    };
  },
  computed: {
    reindeerDisplayName() {
      const names = {
        'buck': 'Bucky',
        'doe-1': 'Jane',
        'doe-2': 'Jo'
      };
      return names[this.selectedReindeer];
    },
    isRudolph: {
      get() {
        return this.rudolphReindeer === this.selectedReindeer;
      },
      set(value) {
        if (value) {
          this.rudolphReindeer = this.selectedReindeer;
        } else if (this.rudolphReindeer === this.selectedReindeer) {
          this.rudolphReindeer = null;
        }
      }
    },
    eyeColor: {
      get() {
        return this.reindeerConfig[this.selectedReindeer].eyeColor;
      },
      set(value) {
        this.reindeerConfig[this.selectedReindeer].eyeColor = value;
        this.sendToWLED();
      }
    },
    bodyColor: {
      get() {
        return this.reindeerConfig[this.selectedReindeer].bodyColor;
      },
      set(value) {
        this.reindeerConfig[this.selectedReindeer].bodyColor = value;
        this.sendToWLED();
      }
    }
  },
  mounted() {
    // Turn off all other Reindeer lights
    command('reindeer-makeover', { action: 'init' });
  },
  methods: {
    toggleRudolph() {
      // Toggle Rudolph status for the selected reindeer
      if (this.rudolphReindeer === this.selectedReindeer) {
        // Unset Rudolph
        this.rudolphReindeer = null;
      } else {
        // Set this reindeer as Rudolph
        this.rudolphReindeer = this.selectedReindeer;
      }
      console.log(`Rudolph is now: ${this.rudolphReindeer || 'none'}`);
      this.sendToWLED();
    },
    
    sendToWLED() {
      // Prepare payload for backend
      const payload = {
        reindeer: {},
        rudolph: this.rudolphReindeer
      };
      
      // Process each reindeer's colors with black handling
      ['buck', 'doe-1', 'doe-2'].forEach(name => {
        const config = this.reindeerConfig[name];
        payload.reindeer[name] = {
          eyeColor: config.eyeColor === '#000000' ? config.bodyColor : config.eyeColor,
          bodyColor: config.bodyColor === '#000000' ? 'off' : config.bodyColor
        };
      });
      
      console.log('Sending to WLED:', payload);

      command('reindeer-makeover', {
        action: 'update',
        data: payload
      })
    }
  }
}
